import { defaultCustomerDetailsFormData } from '../types/data';
export const mapOrderCustomerToFormData = (customer) => {
    var _a, _b;
    return {
        givenName: ((_a = customer.name) === null || _a === void 0 ? void 0 : _a.givenName) || defaultCustomerDetailsFormData.givenName,
        familyName: ((_b = customer.name) === null || _b === void 0 ? void 0 : _b.familyName) || defaultCustomerDetailsFormData.familyName,
        email: customer.email,
        phoneNumber: customer.phoneNumber || defaultCustomerDetailsFormData.phoneNumber
    };
};
